module.exports = __webpack_public_path__ + "img/cards.4af6a981.svg";